module.exports = "/_next/static/images/avatar-e5117e8e0cea57c9a92f0603011083a3.png";